import styled from 'styled-components';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';

const Tag = styled.i`
  ${FontStyles.text11};

  display: block;
  width: 38px;
  height: 22px;
  line-height: 22px !important;
  background-color: ${Colors.orange1};
  color: ${Colors.white1};
  text-align: center;
  font-style: normal;
  border-radius: 4px;
  @media all and (-ms-high-contrast: none) and (min-width:1025px) {
    padding-top: 2px;
  }
  @media all and (-ms-high-contrast: none) and (max-width:1024px) {
    padding-top: 2px;
  }
`;

export default Tag;



// WEBPACK FOOTER //
// ./src/components/common/Tag/index.js